"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function promisify(fn) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return new Promise(function (resolve, reject) {
      fn.apply(void 0, args.concat([function (error, result) {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }]));
    });
  };
}

exports.promisify = promisify;

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

exports.sleep = sleep;

function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0;
}

exports.isEmptyObject = isEmptyObject;

function omit(obj, keys) {
  var newKeys = Object.keys(obj).filter(function (key) {
    return !keys.includes(key);
  });
  return pick(obj, newKeys);
}

exports.omit = omit;

function mapOmit(array, keys) {
  return array.map(function (obj) {
    return omit(obj, keys);
  });
}

exports.mapOmit = mapOmit;

function pick(obj, keys) {
  var result = {};

  for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
    var key = keys_1[_i];

    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }

  return result;
}

exports.pick = pick;